/*
 * @Author: Yun
 * @Date: 2024-02-16 17:16:09
 * @Last Modified by: Yun
 * @Last Modified time: 2024-03-01 07:00:07
 */
import React, { useState } from 'react'
import person1 from '@icons/person1.png'
import person2 from '@icons/person2.png'
import person3 from '@icons/person3.png'
import icon1 from '@images/submission/icon1.png'
import icon2 from '@images/submission/icon2.png'
import icon3 from '@images/submission/icon3.png'
import img1 from '@images/submission/img1.png'
import img2 from '@images/submission/img2.png'
import img3 from '@images/submission/img3.png'
import txtnpc1 from '@images/submission/txtnpc1.png'
import txtnpc2 from '@images/submission/txtnpc2.png'
import txtnpc3 from '@images/submission/txtnpc3.png'
import txtcppcc1 from '@images/submission/txtcppcc1.png'
import txtcppcc2 from '@images/submission/txtcppcc2.png'
import txtcppcc3 from '@images/submission/txtcppcc3.png'
import iconnpc from '@images/submission/iconnpc.png'
import iconcppcc from '@images/submission/iconcppcc.png'
import close from '@icons/close.jpg'
import CgtnJwplayer from '@components/cgtnJwplayer'
import video1 from '@videos/submission1.mp4'
import video2 from '@videos/submission2.mp4'
import video3 from '@videos/submission3.mp4'
import $ from 'jquery'
import './index.less'

const PREFIX = 'submission-page'

const SubmissionPage = (props) => {
    const { id } = props

    const [active, setActive] = useState(false)

    const [type, setType] = useState('npc')

    const onItemClick = (item, type) => {
        $('body').css('overflow', 'hidden')
        setType(type)
        setActive(item)
    }

    const onClose = () => {
        $('body').css('overflow', 'auto')
        setActive(false)
    }

    const handleTxt = (e) => {
        if (e) {
            if (type === 'npc') {
                switch (e) {
                    case 'item1':
                        return (
                            <img
                                className={`${PREFIX}-txtImg ${PREFIX}-txt1`}
                                src={txtnpc1}
                                alt=""
                            />
                        )
                    case 'item2':
                        return (
                            <img
                                className={`${PREFIX}-txtImg ${PREFIX}-txt2`}
                                src={txtnpc2}
                                alt=""
                            />
                        )
                    case 'item3':
                        return (
                            <img
                                className={`${PREFIX}-txtImg ${PREFIX}-txt3`}
                                src={txtnpc3}
                                alt=""
                            />
                        )
                    default:
                        return ''
                }
            } else if (type === 'cppcc') {
                switch (e) {
                    case 'item1':
                        return (
                            <img
                                className={`${PREFIX}-txtImg ${PREFIX}-txt1`}
                                src={txtcppcc1}
                                alt=""
                            />
                        )
                    case 'item2':
                        return (
                            <img
                                className={`${PREFIX}-txtImg ${PREFIX}-txt2`}
                                src={txtcppcc2}
                                alt=""
                            />
                        )
                    case 'item3':
                        return (
                            <img
                                className={`${PREFIX}-txtImg ${PREFIX}-txt3`}
                                src={txtcppcc3}
                                alt=""
                            />
                        )
                    default:
                        return ''
                }
            }
        }
    }

    return (
        <section className={PREFIX} id={id}>
            <div className={`${PREFIX}-timeline`}>
                <div className={`${PREFIX}-timeline-line`}></div>
                <div className={`${PREFIX}-timeline-active`}></div>
                <div className={`${PREFIX}-timeline-dot ${PREFIX}-timeline-dot1`}></div>
                <div className={`${PREFIX}-timeline-dot ${PREFIX}-timeline-dot2`}></div>
                <div className={`${PREFIX}-timeline-dot ${PREFIX}-timeline-dot3`}></div>
            </div>
            <div className={`${PREFIX}-item1`}>
                <img className={`${PREFIX}-icon ${PREFIX}-icon1`} src={icon1} alt="" />
                <img className={`${PREFIX}-img ${PREFIX}-img1`} src={img1} alt="" />
                <img className={`${PREFIX}-person ${PREFIX}-person1`} src={person1} alt="" />
                <CgtnJwplayer
                    className={`${PREFIX}-iconvideo ${PREFIX}-iconvideo1`}
                    id={`${PREFIX}-video1`}
                    videoUrl={video1}
                />
                <div className={`${PREFIX}-buttons`}>
                    <img
                        className={`${PREFIX}-button ${PREFIX}-button-npc`}
                        src={iconnpc}
                        alt=""
                        onClick={() => onItemClick('item1', 'npc')}
                    />
                    <img
                        className={`${PREFIX}-button ${PREFIX}-button-cppcc`}
                        src={iconcppcc}
                        alt=""
                        onClick={() => onItemClick('item1', 'cppcc')}
                    />
                </div>
            </div>
            <div className={`${PREFIX}-item2`}>
                <img className={`${PREFIX}-icon ${PREFIX}-icon2`} src={icon2} alt="" />
                <img className={`${PREFIX}-img ${PREFIX}-img2`} src={img2} alt="" />
                <img className={`${PREFIX}-person ${PREFIX}-person2`} src={person2} alt="" />
                <CgtnJwplayer
                    className={`${PREFIX}-iconvideo`}
                    id={`${PREFIX}-video2`}
                    videoUrl={video2}
                />
                <div className={`${PREFIX}-buttons`}>
                    <img
                        className={`${PREFIX}-button ${PREFIX}-button-npc`}
                        src={iconnpc}
                        alt=""
                        onClick={() => onItemClick('item2', 'npc')}
                    />
                    <img
                        className={`${PREFIX}-button ${PREFIX}-button-cppcc`}
                        src={iconcppcc}
                        alt=""
                        onClick={() => onItemClick('item2', 'cppcc')}
                    />
                </div>
            </div>
            <div className={`${PREFIX}-item3`}>
                <img className={`${PREFIX}-icon ${PREFIX}-icon3`} src={icon3} alt="" />
                <img className={`${PREFIX}-img ${PREFIX}-img3`} src={img3} alt="" />
                <img className={`${PREFIX}-person ${PREFIX}-person3`} src={person3} alt="" />
                <CgtnJwplayer
                    className={`${PREFIX}-iconvideo`}
                    id={`${PREFIX}-video3`}
                    videoUrl={video3}
                />
                <div className={`${PREFIX}-buttons`}>
                    <img
                        className={`${PREFIX}-button ${PREFIX}-button-npc`}
                        src={iconnpc}
                        alt=""
                        onClick={() => onItemClick('item3', 'npc')}
                    />
                    <img
                        className={`${PREFIX}-button ${PREFIX}-button-cppcc`}
                        src={iconcppcc}
                        alt=""
                        onClick={() => onItemClick('item3', 'cppcc')}
                    />
                </div>
            </div>
            {active && (
                <div className={`${PREFIX}-txt`}>
                    <div className={`${PREFIX}-cover`}></div>
                    <img className={`${PREFIX}-close`} src={close} alt="" onClick={onClose} />
                    {handleTxt(active)}
                </div>
            )}
        </section>
    )
}

export default SubmissionPage
